import React, { useEffect } from "react";
import { useGetScriptQuery } from "../features/api/publicApiSlice";

const Script = () => {
    const {
        data: headScript,
        isSuccess: isHeadScriptSuccess,
    } = useGetScriptQuery({ type: "HEAD" });

    const {
        data: bodyScript,
        isSuccess: isBodyScriptSuccess,
    } = useGetScriptQuery({ type: "BODY" });

    useEffect(() => {
        if (!isHeadScriptSuccess || !headScript?.result?.content) return;

        const container = document.createElement("div");
        container.innerHTML = headScript?.result?.content;
        const nodes = Array.from(container.childNodes);

        nodes.forEach((node) => {
            if (node.tagName === 'SCRIPT') {
                const script = document.createElement('script');
                script.async = true;
                if (node.src) {
                    script.src = node.src;
                } else {
                    script.textContent = node.textContent;
                }
                document.head.appendChild(script, document.head.firstChild);
            } else {
                const imported = document.importNode(node, true);
                document.head.appendChild(imported, document.head.firstChild);
            }
        });
    }, [headScript, isHeadScriptSuccess]);

    useEffect(() => {
        if (!isBodyScriptSuccess || !bodyScript?.result?.content) return;

        const container = document.createElement("div");
        container.innerHTML = bodyScript?.result?.content;
        const nodes = Array.from(container.childNodes);

        nodes.forEach((node) => {
            if (node.tagName === 'SCRIPT') {
                const script = document.createElement('script');
                script.async = true;
                if (node.src) {
                    script.src = node.src;
                } else {
                    script.textContent = node.textContent;
                }
                document.body.appendChild(script);
            } else {
                const imported = document.importNode(node, true);
                document.body.appendChild(imported);
            }
        });
    }, [bodyScript, isBodyScriptSuccess]);
    return null;
};

export default Script;
